import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';

export default function FeaturedSection() {
  const featured = [mangaList[5], mangaList[3], mangaList[11], mangaList[0], mangaList[1], mangaList[7]];

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>热门推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">千万读者都在追的必看韩漫</p>
          </div>
          <Link to="/category/romance" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((manga) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}`}
              className="group flex flex-col"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
                <img
                  src={manga.coverImage}
                  alt={manga.title}
                  title={`${manga.title} - 韩漫屋热门推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                    manga.status === '连载中' ? 'bg-primary-500 text-background-50' : 'bg-foreground-700 text-background-50'
                  }`}>
                    {manga.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1 text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                    <span className="text-xs text-white font-medium">{manga.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">{manga.title}</h3>
              <p className="text-xs text-foreground-500 mt-1">{manga.views} 阅读</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}